import localforage from 'localforage';
import { FC, useContext, useEffect, useState } from 'react';
import ContinueButton from '../components/carousel/ContinueButton';
import './WelcomeScreen.scss';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { AppContext } from '../context/Context';
import { IAppContext } from '../types';
import PATH_ROUTES from '../static/constants/path-routes';
import { BRAND, WelcomeImageByBrand, WelcomeItemsMsg } from '../static/constants/brands/brand';
import i18n from '../utils/i18n';
import { Company } from '../interfaces/brand';
import { ActionType } from '../context/actions';

const WelcomeScreen: FC = () => {
  const history = useHistory();
  const {
    state: {
      preInspectionModel: { preInspectionId, preActiveQuestionBroker },
    },
    dispatch,
  } = useContext(AppContext) as IAppContext;
  const [isBroker, setIsBroker] = useState(false);

  const handleContinue = async () => {
    await localforage.setItem('acceptConditions', true);
    
    const routeMapping = {
      [Company.BCR]: PATH_ROUTES.PRE_ONBOARDING_SCREEN,
      [Company.MNK]: PATH_ROUTES.PRE_ONBOARDING_SCREEN,
      [Company.INS]: PATH_ROUTES.PRE_ONBOARDING_SCREEN,
      default: preInspectionId > 0 ? PATH_ROUTES.PRE_INFO_SCREEN : PATH_ROUTES.PRE_ONBOARDING_SCREEN
    };
    
    const targetRoute = routeMapping[BRAND] || routeMapping.default;
    history.push(targetRoute);
  };

  const handleDialogButtonClose = () => {
    dispatch({
      type: ActionType.SET_IS_BROKER,
      payload: false,
    });
    setIsBroker(false);
  };

  const handleDialogButtonContinue = () => {
    dispatch({
      type: ActionType.SET_IS_BROKER,
      payload: true,
    });
    setIsBroker(false);
  };

  const handleDialogClose = (_, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      console.log(reason);
    } else {
      setIsBroker(false);
    }
  };

  const handleBackdropClick = (event: any) => {
    //these fail to keep the modal open
    event.stopPropagation();

    return false;
  };

  useEffect(() => {
    if (preActiveQuestionBroker === true) {
      setIsBroker(true);
    }
  }, []);

  return (
    <>
      <div className="welcome">
        {WelcomeImageByBrand[BRAND] && (
          <img className="welcome__image" src={WelcomeImageByBrand[BRAND]} />
        )}
        <div className="welcome__intro">
          <h1>{i18n.get('welcome.title', 'Hola')}</h1>
          <p
            dangerouslySetInnerHTML={{
              __html: i18n.get(
                'welcome.sub_title',
                'Toma en cuenta que el proceso...',
              ),
            }}
          ></p>
          {WelcomeItemsMsg[BRAND]?.conditions.items.map((item, index) => (
            <div className="welcome__card welcome__card--horizontal" key={index}>
              <div className="avatar-section">
                <img src={item.icon} alt="Avatar" />
              </div>
              <div className="welcome__card__content">
                <h1>{i18n.get(`welcome.conditions.${item.key}.title`)}</h1>
                <p
                  dangerouslySetInnerHTML={{
                    __html: i18n.get(`welcome.conditions.${item.key}.label`)
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <ContinueButton onClick={handleContinue}>{i18n.get('buttons.welcomeContinue', 'Continuar')}</ContinueButton>
      </div>
      <Dialog
        open={isBroker}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onBackdropClick={handleBackdropClick}
      >
        <DialogTitle id="alert-dialog-title">
          {'Confirmación de Corredor'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Es usted el corredor?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="btnWelcomeDialog"
            onClick={handleDialogButtonClose}
            autoFocus
          >
            No
          </Button>
          <Button
            className="btnWelcomeDialog"
            onClick={handleDialogButtonContinue}
          >
            Soy Corredor
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WelcomeScreen;
